/* eslint-disable max-len */
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/rootState';
import { reportHeading } from '../helper';
import { getBase64FromImageUrl } from '../../../utils/CommonFunctions';

function FirstPageSection() {
  const { reportPdfResponse1, checkedSections, themePdfColor } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const frontPageData = reportPdfResponse1?.FrontPage;
  const { selectedSignature } = useSelector((state:RootState) => state.reportWorkspaceReducer);
  const { BorderColor } = themePdfColor;
  const showImage = useMemo(() => (checkedSections?.includes('1') && frontPageData?.LogoUrl?.length > 0), [checkedSections, frontPageData]);

  const [base64Logo, setBase64Logo] = useState<string>();

  useEffect(() => {
    const convertLogo = async () => {
      if (frontPageData?.LogoUrl && checkedSections?.includes('1')) {
        const base64 = await getBase64FromImageUrl(frontPageData?.LogoUrl);
        setBase64Logo(base64);
      }
    };
    convertLogo();
  }, [frontPageData?.LogoUrl]);

  return (
    <>
      <div className="pl30 pr30 pb10 pt0">
        <table className={showImage ? 'w100 mt20' : 'w100 firstPageTable'}>
          <tr>
            <td style={{ width: '65%' }}>
              {showImage && (
              <img src={base64Logo} alt="Logo" className="companyLogo" />
              )}
            </td>
            <td style={{ width: '35%' }}>
              <div style={{
                fontWeight: '600', fontSize: '17px', lineHeight: '22px',
              }}
              >
                {frontPageData?.ClientName}
              </div>
              <div>
                <p style={{
                  whiteSpace: 'pre-line', fontWeight: '600', fontSize: '14px', lineHeight: '16px', marginBottom: 0,
                }}
                >
                  {`${frontPageData?.ClientAddress || ''}${frontPageData?.ClientAddress?.length > 0 ? '\n' : ''}${frontPageData?.ClientOptionalAddress || ''}${frontPageData?.ClientOptionalAddress?.length > 0 ? '\n' : ''}${frontPageData?.ClientCity?.length > 0 ? `${frontPageData?.ClientCity},` : ''} ${frontPageData?.ClientState || ''} ${frontPageData?.ClientZip || ''} ${frontPageData?.ClientCountry || ''}`}
                </p>
              </div>
              <div style={{ fontWeight: '600', fontSize: '14px' }}>
                {frontPageData?.ClientPhone}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="p40">&nbsp;</td>
          </tr>
        </table>
        <table className="w100 logoContentTable valignTopTable">
          <tr>
            <td
              colSpan={2}
              className="textCenter"
              style={{ fontWeight: '600', fontSize: '20px' }}
            >
              {`Report of ${reportHeading(frontPageData?.TestType)}`}
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="p20">&nbsp;</td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600">Manufacturer:</td>
            {/* <td className="w40 textRight">Manufacturer:</td> */}
            <td className="w60">
              {frontPageData?.Manufacturer}
            </td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600">Model:</td>
            <td className="w60">
              {frontPageData?.Model}
            </td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600">Serial:</td>
            <td className="w60">
              {frontPageData?.SerialNumber}
            </td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600">Location:</td>
            <td className="w60">
              {frontPageData?.Location?.split('\n').map((line, index) => (
                <React.Fragment key={`${line[0]}-${index + 1}`}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600">Inspected:</td>
            <td className="w60">
              {frontPageData?.InspectionDate}
            </td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600 vAlignTop">Inspected By:</td>
            <td className="w60 vAlignTop">
              {frontPageData?.InspectedBy}
              <br />
              TAI Services, Inc.
            </td>
          </tr>
          <tr>
            <td colSpan={2}>&nbsp;</td>
          </tr>
          <tr>
            <td className="w40 pl100 fw600">Reviewed By:</td>
            <td className="w60">
              <img
                className="reviewedByImage"
                src={selectedSignature?.Value}
                alt=""
              />
              <div
                className="signatureText"
              >
                {selectedSignature?.Text}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="h120">
              &nbsp;
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="h35 pt40">
              <div className="thickLine" style={{ backgroundColor: BorderColor }}>&nbsp;</div>
              <div className="thinLine" style={{ backgroundColor: BorderColor }}>&nbsp;</div>
            </td>
          </tr>
          <tr>
            <td colSpan={2} className="h35 pt15">
              <div className="footerText textCenter">Inspection performed by TAI Services, Inc.</div>
            </td>
          </tr>
        </table>
      </div>
      {/* <div className="page-break" /> */}
    </>
  );
}

export default FirstPageSection;
